/*
  Input Text
*/

import React from 'react';

// Antd
import { Input, Form } from 'antd';

// Localization
import LOCALIZATION from '../../../../services/LocalizationService';

import { DIGITS_VALIDATIOR } from '../../../../constants/Patterns';

function Number({ 
  name, label, placeholder, 
  readOnly, defaultValue, 
  onChange, disabled, required,
  onBlur, validator, validateTrigger,
  maxLength, notwrapInForm, noRule,
  wholeNumbersOnly, min, max, noNegativeNumbers
}) {

  // Rules
  let rules = [
    { required: required, message: LOCALIZATION.REQUIRED },
    {
      pattern: wholeNumbersOnly ? /^\d+$/ : DIGITS_VALIDATIOR,
      message: wholeNumbersOnly ? LOCALIZATION.WHOLE_NUMBERS_ONLY : LOCALIZATION.DIGITS_VALIDATION
    }
  ];

  // Add negative number validation if prop is set
  if (noNegativeNumbers) {
    rules.push({
      validator: (_, value) => {
        if (value && parseFloat(value) < 0) {
          return Promise.reject(new Error('Negative numbers are not allowed'));
        }
        return Promise.resolve();
      }
    });
  }

  // Custom Validations
  !!validator && rules.push(validator);

  // Handle key down events
  const handleKeyDown = (e) => {
    // Prevent decimal point if whole numbers only
    if (wholeNumbersOnly && (e.key === '.' || e.key === ',')) {
      e.preventDefault();
    }
    
    // Prevent negative sign if no negative numbers allowed
    if (noNegativeNumbers && (e.key === '-' || e.key === 'Minus')) {
      e.preventDefault();
    }
  };

  // Input Number
  const InputNumber = (
    <Input 
      placeholder={ placeholder || label } 
      min={noNegativeNumbers ? Math.max(0, min || 0) : min}
      max={max}
      onChange={ onChange || null } 
      defaultValue={ defaultValue }
      disabled={ disabled }
      onBlur={ onBlur }
      maxLength={ maxLength }
      readOnly={ readOnly }
      type="number"
      step={wholeNumbersOnly ? "1" : "any"}
      onKeyDown={handleKeyDown}
    />
  );

  return(
    !!notwrapInForm?
      <>
        { InputNumber }
      </>:
      <Form.Item
        name={ name }
        label={ label }
        validateTrigger={ validateTrigger || 'onBlur' }
        rules={ noRule? [] : rules }
      >
        { InputNumber }
      </Form.Item>

  );
}

export default Number;